<template>
  <DoctorDashboardCard>
    <template v-slot:title>
      <h3>
        <v-icon class="primary--text pr-2">error_outline</v-icon>
        Rendez-vous d'hôpital de jour refusés
        <v-chip v-show="patients.length">{{patients.length}}</v-chip>
      </h3>
    </template>
    <template v-slot:text>
      <v-list v-if="patients.length" two-line>
        <template v-for="(patient, index) in patients">
          <v-list-tile :key="patient.id">
            <v-list-tile-content>
              <v-list-tile-title>{{patient.first_name}} {{patient.last_name}}</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <router-link class="no-underline"
                           :to="`/doctor/patients/${patient.id}/suivi`">
                <v-btn icon
                       ripple>
                  <v-icon color="primary">arrow_forward</v-icon>
                </v-btn>
              </router-link>
            </v-list-tile-action>

          </v-list-tile>
          <v-divider v-if="index + 1 < patients.length"></v-divider>
        </template>
      </v-list>

      <h2 v-else
          class="text-center pb-5"
          style="color: #757575">Aucun rendez-vous à proposer.</h2>
    </template>
  </DoctorDashboardCard>
</template>

<script>
  import api from 'api'
  import DoctorDashboardCard from 'components/Iriade/DoctorDashboardCard'

  export default {
    components: {
      DoctorDashboardCard
    },

    data() {
      return {
        patients: [],
        ui: {
          loading: true
        }
      }
    },

    mounted() {
      api.get(`dashboard/modules/PrehopRdvDeclinedDoctorDashboardModule`)
        .then(res => {
          this.patients = res.data
          this.ui.loading = false
        })
    }
  }
</script>
